/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planshare_Import_InvalidInputs */

const en_us2_planshare_import_invalid = /** @type {(inputs: Planshare_Import_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That code does not look right. Check the 12 letters and digits.`)
};

const pt_br2_planshare_import_invalid = /** @type {(inputs: Planshare_Import_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse código não parece certo. Confira as 12 letras e números.`)
};

const pt_pt2_planshare_import_invalid = /** @type {(inputs: Planshare_Import_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse código não parece certo. Confira as 12 letras e números.`)
};

/** @type {(inputs: Planshare_Import_InvalidInputs) => LocalizedString} */
const es_419_planshare_import_invalid = en_us2_planshare_import_invalid;

/** @type {(inputs: Planshare_Import_InvalidInputs) => LocalizedString} */
const fr_fr2_planshare_import_invalid = en_us2_planshare_import_invalid;

/** @type {(inputs: Planshare_Import_InvalidInputs) => LocalizedString} */
const de_de2_planshare_import_invalid = en_us2_planshare_import_invalid;

/** @type {(inputs: Planshare_Import_InvalidInputs) => LocalizedString} */
const it_it2_planshare_import_invalid = en_us2_planshare_import_invalid;

/**
* | output |
* | --- |
* | "That code does not look right. Check the 12 letters and digits." |
*
* @param {Planshare_Import_InvalidInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const planshare_import_invalid = /** @type {((inputs?: Planshare_Import_InvalidInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planshare_Import_InvalidInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_planshare_import_invalid(inputs)
	if (locale === "es-419") return es_419_planshare_import_invalid(inputs)
	if (locale === "pt-PT") return pt_pt2_planshare_import_invalid(inputs)
	if (locale === "fr-FR") return fr_fr2_planshare_import_invalid(inputs)
	if (locale === "de-DE") return de_de2_planshare_import_invalid(inputs)
	if (locale === "it-IT") return it_it2_planshare_import_invalid(inputs)
	return en_us2_planshare_import_invalid(inputs)
});
export { planshare_import_invalid as "planshare.import_invalid" }